var fn_masthead = function () {
    // begin masthead video //
    // Video paused when out of viewport
    // See: http://morr.github.io/appear.html
    // Masthead - SPLASH VIDEO
    // Adding class ".Desktop" to activate video injection only on
    // desktop browser
    $('.desktop .slider-hero').each(function () {
        var header = $(this),
            videoPath = header.data('video'),
            covervid = $('<div class="data-is-video-wrapper animated fader"><video playsinline="" autoplay="" muted="" loop="" poster="' + videoPath + '.jpg"  onplaying="this.controls=false" class="slider-hero__video"><source src="' + videoPath + '.mp4" type="video/mp4"></video></div>')
        //
        covervid.find('video').on('canplay', function () {
            covervid.addClass('fadeIn').removeClass('fader')
            header.find('.fader').addClass('animated fadeInUpHeader').removeClass('fader')
        })
        // $(this).append(covervid).find('video').appear()
        // $(this).find('video').on('appear', appearVideo).on('disappear', disappearVideo)
    })

    $('.mobile .masthead-has-video .fader, .tablet .masthead-has-video .fader').addClass('animated fadeInUpHeader').removeClass('fader')

    // $(window).on('load', function () {
        
    //     // Is in viewport detection - see Masthead JS + Covervid JS
    //     // Is in viewport detection - see Masthead JS + Covervid JS
    //     // > Pause video when out of viewport
    //     // See: https://github.com/zeusdeux/isInViewport
    //     // --> Conflict with jquery no conflict so we change for another lib - see below jquery.appear
    //     // See: https://github.com/morr/jquery.appear
    //     //
    //     // Other wise check out: https://www.npmjs.com/package/video-in-view
    //     //
    //     $('video').appear().on('appear', appearVideo).on('disappear', disappearVideo)

    // })
    // end masthead video //
}